import { operators } from '@fr/constants';
import Backbone from 'backbone';
import _ from 'underscore';
import { Operator } from '@ve/types';

const prepareTourIdentities = (tours: Backbone.Model[], product: Backbone.Model): string[] => _.chain(tours)
        .groupBy((tourData) => (tourData.get('product') || product).get('operator').id)
        .values()
        .map((operatorTours) => {
            const sortedTours = _.sortBy(operatorTours, (operatorTour) => operatorTour.get('finalPrice'));
            return sortedTours[0].get('id');
        })
        .value();

const prepareTourProductsWithoutHotelAndRailway = (tourProductsGroup: Backbone.Model[], product: Backbone.Model): Backbone.Model[] => _.chain(tourProductsGroup)
        .filter((tourData) => tourData.get('type') === 'TourProduct')
        .groupBy((tourData) => (tourData.get('product') || product).get('operator').id)
        .values()
        .map((operatorTours) => {
            const sortedTours = _.sortBy(operatorTours, (operatorTour) => operatorTour.get('finalPrice'));
            return sortedTours[0];
        })
        .value();

const getCheapestTravelataTourWithTransfer = (tourProductsGroup: Backbone.Model[]): Backbone.Model | null => {
    const travelataTours = tourProductsGroup.filter((tourProduct) => {
        const operator = tourProduct.get('tour')?.get('operator') as Operator;
        return operators.MY_AGENT.includes(operator?.id);
    });
    const travelataToursWithTransfer = travelataTours.filter((tourProduct) => tourProduct.get('transferType') !== 'none');
    const isTravelataToursWithTransferExists = travelataToursWithTransfer.length > 0;
    return isTravelataToursWithTransferExists ? _.sortBy(travelataToursWithTransfer, (tour) => tour.get('price'))[0] : null;
};

export { prepareTourProductsWithoutHotelAndRailway, prepareTourIdentities, getCheapestTravelataTourWithTransfer };
